// Reserved keys on tool `execute()` return values (plain objects only).
// `AIInferenceSystem` strips these before JSON.stringify on `role: "tool"` messages
// so the model never sees them; they still set "halt after this assistant tool batch".

/** @type {readonly string[]} */
export const REVOLT_HALT_AFTER_ASSISTANT_TOOL_BATCH_KEYS = Object.freeze([
  "__revoltHaltAfterAssistantToolBatch",
  // Legacy / shorter alias (same semantics)
  "__revoltHaltAfterToolBatch",
]);
